import "geojson";
import * as turf from "@turf/turf";
export class RandomLocations {
    inPolygon(polygon, count) {
        const bbox = turf.bbox(polygon);
        const points = [];
        const polygonGeometry = polygon.geometry;
        while (points.length < count) {
            const nextPoints = turf.randomPoint(count - points.length, { bbox: bbox });
            nextPoints.features.forEach(p => {
                if (!turf.booleanPointInPolygon(p.geometry, polygonGeometry))
                    return;
                points.push(p.geometry);
            });
        }
        return turf.featureCollection(points.map(p => turf.feature(p)));
    }
}
export const randomLocations = new RandomLocations();
